import { Component, ElementRef, QueryList, ViewChildren } from '@angular/core';

@Component({
  selector: 'via-search-infographics',
  templateUrl: './search-infographics.component.html',
  styleUrls: ['./search-infographics.component.scss']
})
export class SearchInfographicsComponent {
  @ViewChildren('animate')
  public elementsToAnimate: QueryList<ElementRef>;
}
